const CalTodayIcon = ({ viewBox = "0 0 12 12", className = "hayley-h-3 hayley-w-3 hayley-text-secondary" }) => {
  return (
    <svg viewBox={viewBox} fill="none" className={className}>
      <rect x="1.75781" y="6" width="6" height="6" transform="rotate(-45 1.75781 6)" fill="currentColor" />
    </svg>
  );
};

export default CalTodayIcon;
